// extracted by mini-css-extract-plugin
module.exports = {"big-picture":"BigPictureContainer_big-picture__29CEI","viz":"BigPictureContainer_viz__2di11","branch":"BigPictureContainer_branch__1QqVX"};